import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionTargets, OEVersionFeatureAccess, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OESchoolTargetType as OESchoolTargetType_, OESchoolStartSelectionContent} from './oe-school-consts';

export const OESchoolTargetType = OESchoolTargetType_;

export const OESchoolTargets = new OEVersionTargets(
    {
        [OESchoolTargetType.biology]: [
            OETarget.schoolSkull,
            OETarget.humanBrainNeuron,
            OETarget.humanBrainSynapse,
            OETarget.humanCellEpithelium,
            OETarget.humanBonesSchool,
            OETarget.humanCNS,
            OETarget.humanEarInner,
            OETarget.humanEarMacro,
            OETarget.humanEarMicro,
            OETarget.humanSkinEpidermis,
            OETarget.humanSkin2,
            OETarget.humanEye2,
            OETarget.humanEyeRetina,
            OETarget.humanKnee,
            OETarget.humanGenitalMale,
            OETarget.animalCell,
            OETarget.plantCell,
            OETarget.schoolCellDivision,
            OETarget.virusSarscov2,
            OETarget.animalSnail,
            OETarget.humanMuscleSpindle,
        ],
        [OESchoolTargetType.chemistry]: [
            OETarget.schoolFormelsammlung,
            OETarget.schoolToxin,
            OETarget.schoolAtomicModel,            
        ],
        [OESchoolTargetType.geography]: [
            OETarget.schoolSouthAmerica,
            OETarget.schoolVolcano,
        ],
        [OESchoolTargetType.physics]: [
            OETarget.techEngineOtto,
            OETarget.schoolSolarSystem,
            OETarget.schoolRefrigerator,
        ],
        [OESchoolTargetType.math]: [
            OETarget.schoolGeometrie,
        ]
    },
    {
        [OESchoolTargetType.biology]: OETarget.humanBrainSynapse,
        [OESchoolTargetType.chemistry]: OETarget.schoolFormelsammlung,
        [OESchoolTargetType.geography]: OETarget.schoolSouthAmerica,
        [OESchoolTargetType.physics]: OETarget.techEngineOtto,
        [OESchoolTargetType.math]: OETarget.schoolGeometrie,
    },
    {
        [OESchoolTargetType.biology]: OETarget.humanBrainSynapse
    }
);

export const OESchoolFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    /*
    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            biologyTargetSelection: !isLicensing,
            chemistryTargetSelection: !isLicensing,
            geographyTargetSelection: !isLicensing,
            physicsTargetSelection: !isLicensing,
            mathTargetSelection: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.biologyTargetSelection = true;
                featureAccess.chemistryTargetSelection = true;
                featureAccess.geographyTargetSelection = true;
                featureAccess.physicsTargetSelection = true;
                featureAccess.mathTargetSelection = true;
            }
        }

        return featureAccess;
    }
    */

})(OESchoolTargets);

export const OESchoolStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OESchoolTargets,
    OESchoolStartSelectionContent
);